import { render } from "./AppTopbar.vue?vue&type=template&id=19198d28&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=19198d28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19198d28"

export default script